export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/NoSellingRequests.a1877b01.svg","height":118,"width":300,"blurWidth":0,"blurHeight":0};